import { ICreateDocumentAccess } from 'types/documents/ICreateDocumentAccess';
import {
  convertIDocumentAccessResponseToIDocumentAccessData,
  IDocumentAccessData,
  IDocumentAccessResponse,
} from 'types/documents/IDocumentAccess';
import { AxiosResponse } from 'axios';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';
import { APIFactory } from '../../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../../ui-toolkit/rest/axiosErrorHandler';

export const postGenerateLinkAsync = (createDocumentAccess: ICreateDocumentAccess): Promise<IDocumentAccessData> =>
  APIFactory(baseUrlService.ApiLocation)
    .post('/timber/api/v1/document_accesses', createDocumentAccess)
    .then((response: AxiosResponse<IDocumentAccessResponse>) =>
      convertIDocumentAccessResponseToIDocumentAccessData(response.data)
    )
    .catch(axiosErrorHandler);

export const finalizeDocumentAsync = ({
  documentId,
  versionId,
}: {
  documentId: string;
  versionId: string;
}): Promise<any> =>
  APIFactory(baseUrlService.ApiLocation)
    .put(`/timber/api/internal/documents/${documentId}/versions/${versionId}/finalize`)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
